<template>
    <BaseDialog
        :showDialog="showDialog"
        maxDialogWidth="500"
        headline="lang_LABEL_CONTRACTS_TRACKS_SET_ALL_TRACKS_RELEASES"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">{{ $t('lang_LABEL_CONTRACTS_TRACKS_SET_ALL_TRACKS_RELEASES_DIALOG') }}</v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" v-if="csvLink">
                        <a @click="downloaded = true" :href="csvLink" target="_blank">{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD') }}</a>
                    </v-col>
                    <v-col cols="5">
                        <BaseButton 
                            :disabled="!downloaded"
                            @click="setAllTracksReleases()"
                            label="lang_LABEL_CONTRACTS_TRACKS_SET_ALL_TRACKS_RELEASES"
                            block
                            :alvqa="alvqa + '-button-set-all-tracks-releases'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "AllTracksReleasesDialog",
    props: {
        showDialog: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            downloaded: false,
            alvqa: "error-dialog"
        }
    },
    components: {
        BaseButton,
        BaseDialog
    },
    computed: {
        csvLink: { 
            get() { return this.$store.getters.getDialogSvgLink },
            set(link) { this.$store.commit('setDialogSvgLink', link)}
        },
    },
    methods: {
        setAllTracksReleases() {
            if (this.downloaded) {
                this.$emit('set-all-tracks-releases')
                this.downloaded = false
            }
        },
        closeDialog() {
            this.$emit('closeDialog')
            this.downloaded = false
        }
    }
}
</script>